import type { ThemeAppearance } from '@atlaskit/lozenge';

import { ExecutionStatus, Status } from '@qality/common-model';

export type StatusSelectOption = {
  label: string;
  value: string;
};

export type StatusSelectOptionGroup = {
  label: string;
  options: Array<StatusSelectOption>;
}[];

export type StatusesGroup = {
  label: string;
  options: Array<ExecutionStatus>;
}[];

export default {
  /** JIRA seems to provide wrong or at least color names
   *  blue (todo) have to be gray, yellow (inprogress) have to be blue
   *  On server 9 jira does not provide colors but names : success, inprogress, default
   */
  getAppearanceType(color = ''): ThemeAppearance {
    if (color.startsWith('blue')) {
      return 'default';
    } else if (color.startsWith('purple')) {
      return 'new';
    } else if (color.startsWith('green') || color === 'success') {
      return 'success';
    } else if (color.startsWith('yellow') || color === 'inprogress') {
      return 'inprogress';
    } else if (color.startsWith('red')) {
      return 'removed';
    }
    return 'default';
  },

  isDone(status: Status): boolean {
    return (
      'green' === status?.statusCategory?.colorName ||
      'success' === status?.statusCategory?.colorName
    );
  },

  groupStatusesByCategory(
    statuses: Array<ExecutionStatus>
  ): StatusSelectOptionGroup {
    return this.groupStatuses(statuses, this.mapStatusToOption);
  },

  groupStatusesByCategoryWithoutMapping(
    statuses: Array<ExecutionStatus>
  ): StatusesGroup {
    return this.groupStatuses(statuses, (value) => value);
  },

  groupStatuses(
    statuses: Array<ExecutionStatus>,
    mapper: (value: ExecutionStatus) => StatusSelectOption | ExecutionStatus
  ): StatusSelectOptionGroup | StatusesGroup {
    const options = [
      { label: 'UNFINISHED', options: [] },
      { label: 'FINISHED', options: [] },
    ];

    statuses
      .sort((a, b) => a.position - b.position)
      .forEach((status) => {
        if (status.category === 'UNFINISHED') {
          options[0].options.push(mapper(status));
        } else {
          options[1].options.push(mapper(status));
        }
      });

    return options;
  },

  mapStatusToOption(status: ExecutionStatus): StatusSelectOption {
    return { label: status.name, value: status.id.toString() };
  },
};
